import { Component } from '@angular/core';

@Component({
  templateUrl: './detailed-page.component.html',
  styleUrls: ['./detailed-page.component.scss']
})
export class DetailedPageComponent{
  ww = "100%"
  styleObjj = {
    'flex-direction': 'column',
    'width': '100%'
  }
}
